import { createSlice } from "@reduxjs/toolkit";

const dateFiltersSlice = createSlice({
  name: "dateFilters",
  initialState: {},
  reducers: {
    setDateFilter: (state, action) => {
      const { key, value } = action.payload;
      state[key] = value;
    },
    resetDateFilter: (state, action) => {
      const key = action.payload;
      state[key] = null;
    },
  },
});

export const { setDateFilter, resetDateFilter } = dateFiltersSlice.actions;

export const selectDateFilter = (state, key) =>
  state.dateFilters[key] || null;

export default dateFiltersSlice.reducer;
